// extracted by mini-css-extract-plugin
module.exports = {"commingSoon":"styles_commingSoon__3GNzQ","message":"styles_message__1W6ji","button":"styles_button__A5sq0","button__ok":"styles_button__ok__uO8kV"};